/**
 * 导航栏
 * 
 */

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Tabs, Button, Alert, Pagination } from 'antd';
import { PAPER, ASSIST } from '../../../utils/questionManageType';

import SelectedModal from './SelectedModal'
import SubjectSelect from './SubjectSelect'
import AllowTabs from '../allow_tabs/AllowTabs'

const TabPane = Tabs.TabPane;
// 自定义组件
// import BacktoHP from '../../smarts/BacktoHP';

class BulkImport extends Component {
    state = {
    }

    componentWillMount(){
        /*请求知识点列表接口*/
    }

    componentDidMount(){
        
    }

    /**
     * 学段学科选择完成后，获取到 下面的 allowType列表
     * @return {[type]} [description]
     */
    handleConditionClick = (grade_part, subject) => {
        this.getAllowType(grade_part, subject);
    }

    /**
     * 获取 左右操作列表
     * @return {} [description]
     */
    getAllowType = (grade_part = '10', subject = '0') => {
        // grade_part
        //
        // subject

    }

    /**
     * 获取树列表
     * @return {[type]} [description]
     */
    getTreeList = mold => {
        const { getSourceTreeList, getTargetTreeList } = this.props;
        const { subject, grade_part, source_tab, target_tab, source_rootId, target_rootId, curSourceType, curTargetType } = this.state;
        if (mold === 'source') {
            if (curSourceType == PAPER) {
                getSourceTreeList({ subject, grade_part, type: curSourceType, rootId: curSourceType == ASSIST ? source_rootId : 0, page: 1, pagesize: 20 });
            }else {
                getSourceTreeList({ subject, grade_part, type: curSourceType, rootId: curSourceType == ASSIST ? source_rootId : 0 });
            }
        }else if (mold === 'target') {
            getTargetTreeList({ subject, grade_part, type: curTargetType, rootId: curTargetType == ASSIST ? target_rootId : 0 });
        }
    }

    getSelectedTree = callback => {
        const { getSelectedTreeList } = this.props;
        const { source, target } = this.state;
        getSelectedTreeList({source, target}, callback);
    }
    /**
     * 源tab标签改变时候的回调
     * @param  {String} key [description]
     * @return {[type]}     [description]
     */
    sourceTabChange = key => {
        const { source_tab } = this.state;
        if (source_tab.indexOf(key) < 0) {
            source_tab.push(key);
            this.setState({source_tab, curSourceType: key});
            setTimeout(()=> this.getTreeList('source'), 0);
        }
    }
    /**
     * 目标tab改变的回调
     * @param  {String} key [description]
     * @return {[type]}     [description]
     */
    tabChange = (key, type) => {
        const { source_tab, target_tab } = this.state;
        if (type === 'source') {
            if (source_tab.indexOf(key) < 0) {
                source_tab.push(key);
                this.setState({source_tab, curSourceType: key});
                if (key != ASSIST) {
                    setTimeout(()=> this.getTreeList('source'), 0);
                }
            }
        }else if (type === 'target') {
            if (target_tab.indexOf(key) < 0) {
                target_tab.push(key);
                this.setState({target_tab, curTargetType: key});
                if (key != ASSIST) {
                    setTimeout(()=> this.getTreeList('target'), 0);
                }
            }

        }
    }

    getPaperTreeList = (page = 1, pagesize = 20) => {
        const { getSourceTreeList } = this.props;
        const { subject, grade_part } = this.state;
        getSourceTreeList({ subject, grade_part, type: PAPER, rootId: 0, page, pagesize });
    }

    /**
     * 试卷选项卡中的页码控制
     * @return {[type]} [description]
     */
    handlePageChange = (page,pagesize) => {
        this.getPaperTreeList(page, pagesize);
        document.querySelector('.questionListScroll').scrollTop=0
    }

    /**
     * 试卷选项卡中的每页条数控制
     * @return {[type]} [description]
     */
    handleShowSizeChange = (current, pageSize) => {
        this.getPaperTreeList(current, pageSize);
    }
    /**
     * 树形控件复选操作
     * @param  {[type]} checkedKeys [description]
     * @param  {[type]} info        [description]
     * @return {[type]}             [description]
     */
    handleTreeCheck = (checkedKeys, type, relate_type, info ) => {
        const relate_id = checkedKeys instanceof Array ? checkedKeys : checkedKeys.checked ? checkedKeys.checked : []
        
        let { source, target } = this.state;
        if (type === 'source') {
            let flag = false;
            source.forEach((v, k) => {
                    if (v.relate_type == relate_type) {
                        if (v.relate_type == relate_type) {
                            source[k].relate_id = relate_id;
                        }
                        if (v.relate_id.length) flag = true;
                    }

                }
            )
        this.setState({hasSourceList: flag});
        }else {
            let flag = false;
            target.forEach((v, k) => {
               if (v.relate_type == relate_type) {
                    if (v.relate_type == relate_type) {
                        target[k].relate_id = relate_id;
                    }
                    if (v.relate_id.length) flag = true;
                }
            })
        this.setState({hasTargetList: flag});
        }
        this.setState({source, target});
    }


    handleTreeSelect = (selectedKeys, info) => {
        console.log(selectedKeys, info)
    }

    /**
     * 版本》教辅》知识点 级联列表改变的操作
     * @param  {key值} value 
     * @param  {[type]} type  [description]
     * @return {[type]}       [description]
     */
    handleAssistChange = (value, selectedOptions, type) => {
        if (value.length == 3) {
            const rootId = value[value.length-1];
            if (type === 'source') {
                this.setState({source_rootId: rootId});
            }else if (type === 'target') {
                this.setState({target_rootId: rootId});
            }
            setTimeout(()=> this.getTreeList(type), 0);
        }
    }

    /**
     * 点击查看已选题目
     * @return {[type]} [description]
     */
    handleGetSelectedTree = callback => {
        this.getSelectedTree(callback);
    }

    /**
     * 点击取消已选
     * @return {[type]} [description]
     */
    handleCancelList = () => {

    }

    /**
     * 点击确认导题
     * @return {[type]} [description]
     */
    handleImportQuestion = (obj, callback) => {
        const { importQuestion } = this.props;
        importQuestion(obj,callback);
    }

    render() {

        return (
            <div className="bulkimport_wrap">
                <div>
                    <SubjectSelect handleConditionClick={ this.handleConditionClick } />
                </div>
                {/*{*/}
                    {/*!!error && <Alert style={{margin:'10px 0'}} message= { error } closable type="error" showIcon />*/}
                {/*}*/}
                {/*<div className="node origin_node">*/}
                    {/*{*/}
                        {/*!isGetTypeListFetching && typeList.source &&*/}
                        {/*<AllowTabs*/}
                            {/*size = "small"*/}
                            {/*data = { typeList.source }*/}
                            {/*handleTableChange = { this.handleTableChange }*/}
                            {/*handleAssistChange = { this.handleAssistChange }*/}
                            {/*handleTreeSelect = { this.handleTreeSelect }*/}
                            {/*assistList = { assistList }*/}
                            {/*loading = { isGetTreeListFetching }*/}
                            {/*treeList = { treeList }*/}
                            {/*defaultAssistList = { defaultAssistList }*/}
                            {/*handleGetPaperTreeList = { this.getPaperTreeList }*/}
                        {/*/>*/}
                    {/*}*/}

                {/*</div>*/}
                {/*<div className="node_control">*/}
                    {/*<div>*/}
                        {/*<SelectedModal*/}
                          {/*title="已选列表" */}
                          {/*name="导题" */}
                          {/*handleGetSelectedTree = { this.handleGetSelectedTree }*/}
                          {/*handleImportQuestion = { this.handleImportQuestion }*/}
                          {/*handleCancelList = { this.handleCancelList }*/}
                          {/*data = { selectedTreeList }*/}
                          {/*disabled = { !hasSourceList || !hasTargetList }*/}
                          {/*error = { error }*/}
                          {/*loading= { isGetSelectedTreeListFetching }*/}
                          {/*/>*/}
                    {/*</div>*/}
                {/*</div>*/}
                <div className="node target_node">
                    

                </div>
            </div>
        )
    }
}

function mapState(state) {
    return {
        // userInfo: state.authenticate,
    };
}

function mapDispatch(dispatch) {
    return {

    }
}
export default connect(mapState, mapDispatch)(BulkImport);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/bulk_Import/view.js